import React, { useContext } from 'react';
import { PageContext } from '@/context/PageContext';

import { Box } from '@latitude/box';
import { SecondaryHero } from '@latitude/hero';
import { AccordionSidebar } from '@latitude/accordion';
import { Metadata } from '@latitude/metadata';

import Layout from '@/components/layout';
import { SITE_URL, TITLE_SUFFIX, PRODUCT_NAME } from '@/utils/constants';
import faqs from './_faqs';
import GoMicrositeHeader from './_go-microsite-header';
import FaqHero from './faqHero';
import Section from '@latitude/section-rebrand';
import { AccordionFaqSidebar } from '@latitude/accordion-rebrand';
import { Typography } from '@latitude/typography';

const Faqs = ({ location }) => {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */
  return (
    <Layout location={location} hasSecNav>
      <main
        className="navigation-spacer"
        css={`
          margin-top: 120px !important;
          background-color: #f8f8f8;

          div[class^='MicrositeHeader__SecondBar'].microsite-header__nav-wrap {
            margin-top: 8px;
          }
          
          @media (min-width: 992px) and (max-width: 1200px)  {
            div[class^='MicrositeHeader__SecondBar'].microsite-header__nav-wrap {
              display: -webkit-box;
            }
          }
        `}
      >
        <Metadata
          title={`FAQs | ${TITLE_SUFFIX}`}
          description={`Learn all the handy hints, tips, and answers for everything you wanted to know about your ${PRODUCT_NAME} interest free credit card`}
          keywords="Interest free"
          canonical={`${SITE_URL}${location.pathname}`}
        />
        <GoMicrositeHeader data={state.secondaryNavData} />
          <FaqHero />
          <Section css={`
            padding: 48px 20px;
            `}>
          <AccordionFaqSidebar data={faqs.items} fg/>
          </Section>
      </main>
    </Layout>
  );
};

export default Faqs;
